import React, { Component } from 'react';
import '../App.css';
import { Row, Col, Grid }
  from 'react-bootstrap';

class PlayStore extends Component {
  render() {
    if (Object.keys(this.props.content).length !== 0) {
      //console.log(this.props.content)

      return (
        <div className="store_box">
          <div className="store_header">
            <span>Play Store:</span>
          </div>
          <Grid fluid>
            <Row>
              { this.props.content[1].map(function(value, index, array){
                return {picUrl: value, name: this.props.content[0][index + 1], url: this.props.content[2][index], i: index}
              }.bind(this)).map(source => (
                <Col sm={4} key={source.name + source.i}>
                  <div className="app_result">
                    <div className="app_icon" style={{"backgroundImage" : "url(" + source.picUrl + ")"}} >
                    </div>
                    <a className="app_name" href={source.url} target="_blank">
                      {source.name}
                    </a>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
          <div className="store_info">
            {this.props.content[0][0]}
          </div>
        </div>
      );
    } else {
      return (
        <div className="store_box">
          <div className="store_header">
            <b>Play Store:</b>
          </div>
          <div className="ebay_results">
            <p>Loading...</p>
          </div>
        </div>
      );
    }
  }
}

export default PlayStore;



// WEBPACK FOOTER //
// ./client/src/Engines/PlayStore.js